import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  data: [],
  error: null,
}

export const auditProcessSlice = createSlice({
  name: 'auditProcess',
  initialState,
  reducers: {
    auditProcessListLoading: (state) => {
      state.loading = true
      state.data = []
      state.error = null
    },
    auditProcessListSuccess: (state, action) => {
      state.loading = false
      state.data = action.payload
      state.error = null
    },
    auditProcessListError: (state, action) => {
      state.loading = false
      state.data = []
      state.error = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { auditProcessListLoading, auditProcessListSuccess, auditProcessListError } = auditProcessSlice.actions

export default auditProcessSlice.reducer;